import "./Footer.css";

function Footer() {
  return (
    <>
      <span>Copyright © 2021 Sanoh Production Achievement</span>
      {/* <span className="kelola-heart">
        <i className="mdi mdi-heart" />
      </span>
      <span>in Karawang</span> */}
    </>
  );
}

export default Footer;
